"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = exports.Error = void 0;
const i18next_1 = __importDefault(require("i18next"));
i18next_1.default.init({
    lng: 'en',
    resources: {
        en: {
            translation: {
                "ER000": "The function is not currently implemented",
                "ER000D": "Internal library error",
                "ER001": "No such ID was found",
                "ER001D": "No such ID was found",
                "ER002": "The password does not match the private key",
                "ER002D": "Wrong password",
                "ER003": "The signed json does not have the proper structure",
                "ER003D": "Malformed signed json structure",
                "ER004": "The signatures structure should be a map, and it isn't",
                "ER004D": "Invalid signed json structure",
                "ER005": "Some of the required fields to create a signature are missing",
                "ER005D": "Invalid signed json structure",
                "ER006": "The signature version is not supported by this library",
                "ER006D": "Unsupported signature version",
                "ER007": "An object does not have the correct type",
                "ER007D": "Malformed signed json structure",
                "ER008": "The object contains an invalid value",
                "ER008D": "Malformed signed json structure"
            }
        },
        es: {
            translation: {
                "ER000": "La función no está implementada",
                "ER000D": "Error interno en la biblioteca cryptosat-ts",
                "ER001": "No se encontró tal ID",
                "ER001D": "No se encontró tal ID",
                "ER002": "La contraseña no coincide con la llave privada",
                "ER002D": "Password equivocado",
                "ER003": "The signed json does not have the proper structure",
                "ER003D": "Malformed signed json structure",
                "ER004": "The signatures structure should be a map, and it isn't",
                "ER004D": "Invalid signed json structure",
                "ER005": "Some of the required fields to create a signature are missing",
                "ER005D": "Invalid signed json structure",
                "ER006": "The signature version is not supported by this library",
                "ER006D": "Unsupported signature version",
                "ER007": "An object does not have the correct type",
                "ER007D": "Malformed signed json structure",
                "ER008": "The object contains an invalid value",
                "ER008D": "Malformed signed json structure"
            }
        }
    }
});
/**
 * Clase de retorno de cualquier promesa dentro de la biblioteca
 */
class Error {
    /**
     * Constructor para los errores que regresa prácticamente toda la biblioteca.
     *
     * @param code Código de error
     * @param detail Detalle, opcional, utilizado para reducir el número de códigos de error
     *
     * ```typescript
     * import * as cs from 'cryptosat-ts';
     *
     * let e = new cs.Error(cs.ErrorCode.Unimplemented);
     * console.log(e.display());
     * ```
     */
    constructor(code, detail) {
        /**
         * Regresa el código asociado a este error
         *
         * @returns Código de error
         *
         * ```typescript
         * import * as cs from 'cryptosat-ts';
         *
         * let e = new cs.Error(cs.ErrorCode.Unimplemented);
         * console.log(er.get_code());
         * ```
         */
        this.get_code = () => {
            return this.__code;
        };
        /**
         * Da una explicación para el programador de la razón del error
         *
         * @returns Explicación del error
         *
         * * ```typescript
         * import * as cs from 'cryptosat-ts';
         *
         * let e = new cs.Error(cs.ErrorCode.Unimplemented);
         * console.log(er.detail());
         * ```
         */
        this.detail = () => {
            return i18next_1.default.t(this.__code) + this.__detail != undefined ? ` (${this.__detail})` : '';
        };
        /**
         * Da una explicación para el usuario final de la razón del error.
         *
         * @returns Explicación del error para usuarios finales
         *
         * * ```typescript
         * import * as cs from 'cryptosat-ts';
         *
         * let e = new cs.Error(cs.ErrorCode.Unimplemented);
         * console.log(er.display());
         * ```
         */
        this.display = () => {
            return i18next_1.default.t(this.__code + "D");
        };
        this.__code = code;
        this.__detail = detail;
    }
}
exports.Error = Error;
/**
 * Códigos de error de la biblioteca
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["Unimplemented"] = "ER000";
    ErrorCode["NoSuchId"] = "ER001";
    ErrorCode["WrongPass"] = "ER002";
    ErrorCode["WrongStructure"] = "ER003";
    ErrorCode["WrongSignaturesStructure"] = "ER004";
    ErrorCode["MissingFields"] = "ER005";
    ErrorCode["UnsupportedVersion"] = "ER006";
    ErrorCode["WrongType"] = "ER007";
    ErrorCode["InvalidValue"] = "ER008";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
//# sourceMappingURL=error.js.map